import Hero from "../components/Home/Hero"
import Courses from "../components/Home/Courses"
import About from "../components/Home/About"
import RandomQuote from "../components/Home/RandomQuote"
export default function Home () {
  return (
    <div>
      <Hero />
      <Courses />
      <About />
      <RandomQuote />
    </div>
  )
}
